module.exports = __webpack_public_path__ + "static/media/Cruiser.efd2afbf.svg";